import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { WidgetContent } from '@models/widget/widget-content.interface';
import { Router , RouterModule } from '@angular/router';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { ActionType } from '@models/widget/action-type.enum';
import{ NavigationService } from '@services/navigation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-redirect-widget',
  templateUrl: './redirect-widget.component.html',
  styleUrls: ['./redirect-widget.component.css'],
})
export class RedirectWidgetComponent implements OnInit {
  @Input() widgetContent: WidgetContent
  policyList: any[];
  isLoading: boolean;

constructor(            
      private policyDataService: PolicyDataService,
      private router: Router,
      private navService: NavigationService
    ){}

  public ngOnInit() {
    this.isLoading = true;
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policyList = policyResponse;
        this.isLoading = false;
      }
    });
  }

  public onClick() {
    if (this.isLoading) return;
    this.navService.saveCurrentAction(this.widgetContent.type);
    if(
        ActionType.DiscoverRewards === this.widgetContent.type
        || ActionType.FindRoadsideAid === this.widgetContent.type
    ){
      window.open(this.widgetContent.route[0], '_blank');
    }else{

      const policyPlace = this.widgetContent.route.indexOf("");
      const route = [...this.widgetContent.route];
      if(policyPlace !== -1){
        route[policyPlace] = this.policyList[0].policynumber.policyNumber;
      }

      if(this.policyList.length === 1 && this.widgetContent.fragment){
        this.router.navigate(route, { 
          fragment: this.widgetContent.fragment,
         });
      }else{
        this.router.navigate(route);
      }      
    }
  }
}
